import GettingStarted from "./GettingStarted";

const Guides = [GettingStarted];

export default Guides;
